module.exports = __webpack_public_path__ + "static/img/kefu.e2be3d1a.png";